import React from 'react';
import { ContentLayout } from './ContentLayout';
import { motion } from 'framer-motion';
import { Calendar, User } from 'lucide-react';
import { SEO } from '../SEO';

interface BlogPostPageProps {
    slug: string;
    title: string;
    excerpt: string;
    author: string;
    date: string;
    content: React.ReactNode;
    onGetStarted: () => void;
}

export const BlogPostPage: React.FC<BlogPostPageProps> = ({ title, excerpt, author, date, content, onGetStarted }) => {
    return (
        <ContentLayout title={title} description={excerpt} onGetStarted={onGetStarted}>
            <SEO
                title={title}
                description={excerpt}
                type="article"
                keywords={['blog', 'visual thinking', 'ai', 'notespace']}
                author={author}
            // url={`https://www.notesscape.in/blog/${slug}`} // Assuming slug is passed or available via context if needed, strictly prop based here
            />
            <article className="max-w-4xl mx-auto px-6 py-12 lg:py-20">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight">
                        {title}
                    </h1>
                    <p className="text-xl text-slate-600 dark:text-slate-400 mb-8 max-w-2xl mx-auto">
                        {excerpt}
                    </p>

                    <div className="flex items-center justify-center gap-6 text-sm text-slate-500 dark:text-slate-400">
                        <div className="flex items-center gap-2">
                            <User className="w-4 h-4" />
                            {author}
                        </div>
                        <div className="flex items-center gap-2">
                            <Calendar className="w-4 h-4" />
                            {date}
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="prose prose-lg dark:prose-invert mx-auto"
                >
                    {content}
                </motion.div>
            </article>
        </ContentLayout>
    );
};
